import { Button } from '@/components/ui/button';
import { Play } from 'lucide-react';
import { PWAInstallPrompt } from './PWAInstallPrompt';

interface LandingScreenProps {
  onStart: () => void;
}

export const LandingScreen = ({ onStart }: LandingScreenProps) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 relative overflow-hidden">
      <PWAInstallPrompt />
      {/* Subtle background glow */}
      <div 
        className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full opacity-20 pointer-events-none"
        style={{
          background: 'radial-gradient(circle, hsl(47 100% 72% / 0.3) 0%, transparent 70%)',
        }}
      />

      <div className="relative z-10 max-w-md w-full text-center space-y-12">
        {/* Wolf emoji as simple visual */}
        <div className="text-8xl slide-up">🐺</div>

        {/* Title */}
        <div className="space-y-4 slide-up" style={{ animationDelay: '0.1s' }}>
          <h1 className="font-display text-4xl md:text-5xl text-foreground text-glow leading-tight">
            Le Loup-Garou,
            <br />
            <span className="text-moon">animé par une IA</span>
          </h1>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Aucun animateur. Un seul téléphone.
            <br />
            Une expérience immersive.
          </p>
        </div>

        {/* CTA */}
        <div className="space-y-4 slide-up" style={{ animationDelay: '0.2s' }}>
          <Button 
            variant="blood" 
            size="game"
            className="w-full pulse-blood"
            onClick={onStart}
          >
            <Play className="w-5 h-5 mr-2" />
            Lancer une partie
          </Button>
          
          <p className="text-sm text-muted-foreground">
            Gratuit • Sans inscription
          </p>
        </div>
      </div>
    </div>
  );
};
